module.exports = __webpack_public_path__ + "05_long_yellow.d2bd2d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/05_long_yellow.png
// module id = 3ygX
// module chunks = 0